import type { App } from "vue";
import { BaseButton } from "./Button";

export const setupGlobCom = (app: App<Element>): void => {
  app.component("BaseButton", BaseButton);
};
